import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 1rem;

  h4 {
    color: #333;
    font-weight: 600;
    border-bottom: 2px solid #007bff;
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
  }

  h5 {
    color: #666;
    font-weight: 500;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 2rem;

  @media only screen and (min-width: 1100px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 1rem;
    gap: 0.3rem;
  }

  @media only screen and (max-width: 1099px) and (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1rem;
    gap: 0.3rem;
  }

  .label {
    font-size: 11px;
    font-weight: 500;
    text-align: left;
  }

  label {
    display: grid;
    grid-template-columns: 1fr 3fr;
    text-align: left;

    @media only screen and (max-width: 600px) {
      grid-template-columns: 1fr;
      .label {
        display: none;
      }
    }
  }

  label > .label {
    text-align: right;
    margin-right: 0.5rem;

    @media only screen and (max-width: 600px) {
      text-align: left;
      margin-right: 0;
    }
  }
`;

export const ProductSection = styled.div`
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;

  h5 {
    color: #495057;
    font-size: 1.1rem;
  }

  .btn-danger {
    background-color: #dc3545;
    border-color: #dc3545;
  }

  .btn-success {
    background-color: #28a745;
    border-color: #28a745;
  }
`;